<template>
  <div>
    <div class="mask" :class="{ maskActive: isOpen }" @click="closeSelf" />
    <!-- mb版 上滑popup -->
    <transition name="slide-up">
      <div
        v-if="dataLoad && isOpen"
        id="dialog-market"
        :class="{ active: isOpen }"
        class="dialog-bottom"
      >
        <div class="dialog-inner">
          <div class="cart-content">
            <a class="btn-delete" @click.prevent="closeSelf">
              <i class="icon-close" />
            </a>
            <div class="item-detail" @click.prevent="closeSelect">
              <div class="item-img">
                <NewImage
                  v-if="selected.Images?.length !== 0"
                  :url="selectedProductCoverImage?.Url"
                  :size="'_w752_h956'"
                  :name="allData.Name"
                />
              </div>
              <div class="item-info">
                <div class="item-order">
                  <div class="brand-name">
                    {{ allData.Brand?.Name }}
                  </div>
                  <div class="item-name">
                    {{ allData.Name }}
                  </div>
                  <div class="item-price">
                    <span v-if="mapOriginPrice" class="origin-price">
                      NT$ {{ allData?.OriginPrice?.toLocaleString() }}
                    </span>
                    <span class="sell-price">NT$ {{ mapSellPrice }}</span>
                  </div>
                  <div v-if="allData.Limit !== 0" class="item-limit">
                    此商品限購 {{ allData.Limit }} 件
                  </div>
                  <ul class="item-event">
                    <li v-for="event in allData.Events" :key="event.ID">{{ event.Name }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="item-pick">
              <div class="select-block">
                <div class="select-style" :class="{ spread: sizeBtn }">
                  <a class="select-btn" @click.prevent.stop="openSelector">{{ selected.Name }}</a>
                  <ul class="select-opts" :class="{ isopen: selectIsOpen }">
                    <li
                      v-for="color in allData.Colors"
                      :key="color.ID"
                      @click="changeImg(color.ID)"
                    >
                      {{ color.Name }}
                    </li>
                  </ul>
                </div>
                <Selector
                  v-if="!sizeBtn"
                  :options="selected.Specs"
                  :selected="selectedSpec"
                  @cb="selectSpec"
                />
              </div>
              <Quantity
                class="mb-2"
                :counter="counter"
                :reduce-count="() => reduceCount()"
                :add-count="() => addCount()"
              />
              <button
                class="btn btn-primary w-100 btn-add2cart"
                :class="btnStyleGenerate"
                @click.prevent="addToCart"
              >
                {{ btnDescriptionGenerate }}
              </button>
            </div>
            <div v-if="selectedSpec !== null && selectedSpec.PreOrder" class="product-arrival">
              {{ allData.ArrivalExplanation }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed, watch, toRefs } from 'vue';
import $ from 'jquery';

import gtmTrace from '@global/gtm/trace';
import { fireAddToCart, fireMemberFavoriteAddToCart } from '@global/gtm/common';

import useMiniCartStore from '@global/stores/useMiniCartStore';
import useModalStore from '@global/stores/useModalStore';

import useUtmKDetect from '@global/composable/useUtmKDetect';
import useMsg from '@global/composable/useMessage';
import useAlert from '@global/composable/useAlert';
import useDialog from '@composable/useDialog';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import NewImage from '@global/components/common/Image/NewImage.vue';

import Selector from '@components/Select.vue';
import Quantity from '@components/Quantity.vue';

import { btnDescriptionEnum, btnStyleEnum } from '@/models/productEnum';

const { utmKDetect, shareCode } = useUtmKDetect();
const { messageBox } = useMsg();
const { alertDialog } = useAlert();
const { dialogData, changeOpen } = useDialog();
const { postShoppingCartAPI } = useAxiosAPI();

const modalStore = useModalStore();
const { closeModal, openModal } = modalStore;

const { isOpen, allData, selectedID, dataLoad, listName } = toRefs(dialogData.value);

const selectedSpec = ref({ Name: '尺寸', Key: 'default' });
const selectedSpecKey = ref(null);

/**
 * 跳窗時產品選擇
 */
const category = $('.member-page-title').text();
const selected = ref({});
const selectedProductCoverImage = computed(() => {
  return selected.value.Images?.find((element) => element.Category === 11);
});

const sizeBtn = computed(() => {
  // 非服飾類 & 單一顏色尺寸 & 尺寸為F，須隱藏尺寸下拉選單
  return (
    category !== 'APPAREL' &&
    selected.value.Specs?.length === 1 &&
    selected.value.Specs[0]?.Name === 'F' &&
    selected.value.Specs[0]?.Stock > 0
  );
});

const btnStyle = ref('disabled');
const btnStyleGenerate = computed({
  get: () => {
    if (allData.value.IsPreShow) {
      return 'disabled';
    }
    return btnStyle.value;
  },
  set: (newVal) => {
    btnStyle.value = newVal;
  },
});

const btnDescription = ref('請選擇尺寸');
const btnDescriptionGenerate = computed({
  get: () => {
    if (allData.value.IsPreShow) {
      return 'COMING SOON';
    }
    return btnDescription.value;
  },
  set: (newValue) => {
    btnDescription.value = newValue;
  },
});
const mapOriginPrice = computed(() => {
  if (Object.keys(allData.value)?.length !== 0) {
    return allData.value.SellPrice !== allData.value.OriginPrice || allData.value.EventPrice > 0;
  }

  return false;
});
const mapSellPrice = computed(() => {
  if (Object.keys(allData.value)?.length !== 0) {
    return allData.value.EventPrice > 0 && allData.value.EventPrice < allData.value.SellPrice
      ? allData.value.EventPrice
      : allData.value.SellPrice;
  }

  return null;
});

/**
 * 更換不同選項時
 */
watch(selectedID, (nV) => {
  selectedSpec.value = { Name: '尺寸', Key: 'default' };
  getSelectedData();
  checkIfOnlyOneHasStock();
});

function getSelectedData() {
  allData.value.Colors?.forEach((element) => {
    if (element.ID === selectedID.value) {
      selected.value = element;
    }
  });
}
function checkIfOnlyOneHasStock() {
  if (selected.value.Specs?.length === 1 && selected.value.Specs[0]?.Stock > 0) {
    selectSpec(selected.value.Specs[0]);
  }
}

/**
 * 數量計算
 */
const counter = ref(1);
const limit = allData.value.Limit;
function resetCounter() {
  counter.value = 1;
}
function addCount() {
  if (selectedSpec.value.Key === 'default') return;
  if (allData.value.IsPreShow) return;
  if (counter.value >= selectedSpec.value.Stock) return;
  if (counter.value >= limit && limit !== 0) return;
  counter.value += 1;
}
function reduceCount() {
  if (counter.value <= 1) return;
  counter.value -= 1;
}

// 連帶變更
function selectSpec(spec) {
  if (spec.Key === 'default') {
    btnStyleGenerate.value = 'disabled';
    btnDescriptionGenerate.value = btnDescriptionEnum.general;
    clearSpec();
    return;
  }

  selectedSpec.value = spec;
  selectedSpecKey.value = spec.Key;
  resetCounter();
  btnActive(spec.Stock, spec.PreOrder);
}
function btnActive(stock, isPreOrder) {
  if (allData.value.IsPreShow) {
    btnStyleGenerate.value = 'disabled';
    return;
  }

  if (stock === 0) {
    if (isPreOrder) {
      // 無庫存預購
      btnStyleGenerate.value = btnStyleEnum.disabled;
      btnDescriptionGenerate.value = btnDescriptionEnum.soldOut;
    } else {
      btnStyleGenerate.value = btnStyleEnum.activeMail;
      btnDescriptionGenerate.value = btnDescriptionEnum.notice;
    }
  } else {
    btnStyleGenerate.value = btnStyleEnum.active;
    btnDescriptionGenerate.value = btnDescriptionEnum.addBag;
  }
}

/**
 * 換顏色/規格
 */
const selectIsOpen = ref(false);
function openSelector() {
  selectIsOpen.value = !selectIsOpen.value;
}
function changeImg(colorID) {
  selectIsOpen.value = false;
  if (selected.value.ID === colorID) return;

  btnReset();
  clearSpec();
  resetCounter();
  selectedID.value = colorID;
}

/**
 * 關閉跳窗
 */
function closeSelf() {
  changeOpen(false);
  btnReset();
  clearSpec();
}
function clearSpec() {
  selectedSpec.value = { Name: '尺寸', Key: 'default' };
  selectedSpecKey.value = null;
  selectedID.value = null;
}
function closeSelect() {
  selectIsOpen.value = false;
}

/**
 * 共用
 */
function btnReset() {
  btnStyleGenerate.value = 'disabled';
  btnDescriptionGenerate.value = btnDescriptionEnum.general;
}

/**
 * 新增購物車
 */
const itemSpecInfo = ref('');
const miniCartStore = useMiniCartStore();
const { getCartInfo } = miniCartStore;

function addToCart() {
  if (allData.value.IsPreShow) return;

  if (selectedSpec.value === null) {
    alertDialog.alert('請選擇尺寸');
    return;
  }

  const marketID = allData.value.CustomMarketID?.substring(
    0,
    allData.value.CustomMarketID?.indexOf('CL'),
  );

  itemSpecInfo.value = `${marketID}CL${selectedID.value}SZ${selectedSpecKey.value}`;

  if (selectedSpec.value.Stock === 0) {
    if (selectedSpec.value.PreOrder) {
      return;
    }
    openModal('arrivalNotice');
    return;
  }

  const utmData = utmKDetect(itemSpecInfo.value) === null ? null : utmKDetect(itemSpecInfo.value);
  const shareCodeData = shareCode() === null ? null : shareCode();

  postShoppingCartAPI({
    CustomMarketID: itemSpecInfo.value,
    Count: counter.value,
    UtmTag: utmData,
    ShareCode: shareCodeData,
  })
    .then((res) => {
      if (res.data.Code === 200) {
        if (document.body.id === 'page-shop-content') {
          closeModal();
        }

        if (document.body.id === 'page-cart') {
          setTimeout(() => {
            window.location.href = '/zh-tw/checkout';
          }, 1000);
        }

        messageBox.cart('商品加入購物車');

        getCartInfo();

        // GTM TODO: 待測試
        gtmTrace.addToCart({
          name: allData.value.Name,
          id: itemSpecInfo.value,
          price: allData.value.OriginPrice,
          sale_price: mapSellPrice.value,
          img_url: selectedProductCoverImage.value?.Url,
          product_url: selected.value.MarketUrl,
          color: selected.value.Name,
          count: counter.value,
        });

        // GTM TODO: 待測試
        fireAddToCart({
          item_id: itemSpecInfo.value.split('SZ')[0],
          item_name: allData.value.Name,
          index: 0,
          affiliation: selected.value.Name,
          item_brand: selectedSpec.value.Name,
          item_list_name: listName.value,
          price: mapSellPrice.value,
          quantity: counter.value,
          item_variant: selectedSpec.value.Barcode,
        });

        // GTM TODO: 待測試
        if (listName.value === '會員收藏清單') {
          fireMemberFavoriteAddToCart({
            productId: itemSpecInfo.value.split('SZ')[0],
            productName: allData.value.Name,
            addFavoriteItem: {
              item_id: itemSpecInfo.value.split('SZ')[0],
              item_name: allData.value.Name,
              index: 0,
              affiliation: selected.value.Name,
              item_brand: selectedSpec.value.Name,
              item_list_name: listName.value,
              price: mapSellPrice.value,
              quantity: counter.value,
              item_variant: selectedSpec.value.Barcode,
            },
          });
        }

        closeSelf();
      } else if (res.data.Code === 205) {
        alertDialog.alert('商品已售完', () => {
          window.location.reload();
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
</script>
